import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'

import { api } from '@/services/base'
import reducer from '@/state/reducer'

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(api.middleware),
})

export const persistor = persistStore(store)
